import type {
  ICprMathContext,
  IProcessedTowLogSection,
} from '../interface/cpr-math-context.interface';
import { getProcessedTowLogSections } from './tow-log-sections';
import { getTowedMiles } from './towed-miles';

export function getTowMileageStats(
  context: ICprMathContext<unknown>,
): Record<'towMileage' | 'sampledMileage' | 'milesPerDivision', number | null> {
  const { tow } = context;

  if (!tow) {
    throw TypeError('Missing tow');
  }

  const towMileage = getTowedMiles(context);

  if (tow.milesPerDivision && tow.sampledMileage) {
    return {
      towMileage,
      milesPerDivision: tow.milesPerDivision,
      sampledMileage: tow.sampledMileage,
    };
  }

  let section: IProcessedTowLogSection<unknown> | undefined;

  if (tow.silkReadingStart !== null && tow.silkReadingEnd !== null) {
    section = getProcessedTowLogSections(context)[0];
  }

  const milesPerDivision = tow.milesPerDivision ?? section?.milesPerDivision ?? null;

  let sampledMileage = tow.sampledMileage ?? null;

  if (!sampledMileage && towMileage !== null && milesPerDivision !== null) {
    sampledMileage = towMileage - milesPerDivision;
  }

  return {
    towMileage,
    milesPerDivision,
    sampledMileage,
  };
}
